<template>
  <div id="app">
    <router-view />
    <popup-loading v-if="loading"></popup-loading>
  </div>
</template>

<script>
import { PopupLoading } from './components/popup'
import { mapState } from 'vuex'
export default {
  components: {
    PopupLoading
  },
  computed: {
    ...mapState(['loading'])
  }
}
</script>

<style lang="less">
body {
  background: #F9F9F9;
  padding: 0;
  margin: 0;
  height: 100vh;
  color: #333333;
  font-family: 'Montserrat-Medium';
}
#app {
  font-size: 28px;
}
.btn {
  height: 86px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  background: #5fbc8e;
  font-size: 32px;
  border-radius: 20px;
}
.textbtn{
  margin: 30px auto;
  text-align: center;
  color: #347dff;
}
@font-face {
  font-family: "Montserrat-Medium";        //自定义字体名称
  src:url('./assets/Montserrat-Medium.otf');       //字体包路径
  font-weight: bold;
  font-style: normal;
}
@font-face {
  font-family: "Montserrat-Regular";        //自定义字体名称
  src:url('./assets/Montserrat-Regular.otf');       //字体包路径
  font-weight: bold;
  font-style: normal;
}
.grecaptcha-badge {
  display: none;
}
</style>
